import { transformZoomData } from 'choerodon-ui/shared/util';
import { cloneElement, memo, useCallback, useState } from 'react';
function wrapEvent(element, eventName, callback) {
    return e => {
        const originalEvent = element.props[eventName];
        if (originalEvent) {
            originalEvent(e);
        }
        callback(e);
    };
}
const MouseDown = function MouseDown(props) {
    const [size, setSize] = useState();
    const show = useCallback(e => {
        const { currentTarget } = e;
        const pos = currentTarget.getBoundingClientRect();
        const { ownerDocument } = currentTarget;
        const defaultView = ownerDocument && ownerDocument.defaultView;
        setSize({
            x: transformZoomData(e.clientX) - pos.left,
            y: transformZoomData(e.clientY) - pos.top,
            width: currentTarget.clientWidth,
            height: currentTarget.clientHeight,
            position: defaultView ? defaultView.getComputedStyle(currentTarget).position : null,
        });
    }, []);
    const hide = useCallback(() => {
        setSize(undefined);
    }, []);
    const { children, rippleChild } = props;
    const element = children(rippleChild, size);
    const newProps = {
        onMouseDown: wrapEvent(element, 'onMouseDown', show),
    };
    if (size) {
        Object.assign(newProps, {
            onMouseUp: wrapEvent(element, 'onMouseUp', hide),
            onMouseLeave: wrapEvent(element, 'onMouseLeave', hide),
            onDragEnd: wrapEvent(element, 'onDragEnd', hide),
        });
    }
    return cloneElement(element, newProps);
};
MouseDown.displayName = 'MouseDown';
export default memo(MouseDown);
